let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g3r6l")).then(() => parcelRequire('hTfdg'));